import type { PostImage } from '../../types/index.ts';
import { useCallback, useMemo } from 'react';
import { useDialog } from '@_/hooks';
import { Image } from '@_/ui';
import { ImageCarousel } from '../ImageCarousel/index.ts';
import { ImageDialog } from '../ImageDialog/index.ts';
import { PostGalleryGrid } from '../PostGalleryGrid/index.ts';

interface TextPostGalleryProps {
  images: PostImage[];
}

export function TextPostGallery({ images }: TextPostGalleryProps) {
  const imageUrls = useMemo(
    () =>
      images
        .slice()
        .sort((a, b) => (a.position < b.position ? -1 : 1))
        .map(image => image.imageUrl),
    [images]
  );

  const imageDialog = useDialog({
    component: ImageDialog,
    openFunctionArgsToProps: (initialIndex: number) => ({ initialIndex }),
    props: { imageUrls }
  });

  const handleClickImage = useCallback(
    (index: number) => {
      imageDialog.open(index);
    },
    [imageDialog]
  );

  return (
    <>
      {imageDialog.element}

      <div>
        <div className="aspect-square sm:hidden">
          <ImageCarousel imageUrls={imageUrls} initialIndex={0} showDots />
        </div>
        <div className="hidden sm:block">
          <PostGalleryGrid items={images}>
            {({ imageProps, index, item }) => (
              <a
                href={item.imageUrl}
                onClick={e => {
                  e.preventDefault();
                  handleClickImage(index);
                }}
              >
                <Image {...imageProps} />
              </a>
            )}
          </PostGalleryGrid>
        </div>
      </div>
    </>
  );
}
